exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.MotivodeBaja\n  div.ag-layout-auto-height:nth-child(2)\n  > div:nth-child(1)\n  > div:nth-child(1)\n  > div:nth-child(1) {\n  display: none;\n}\n.MotivodeBaja div.ag-layout-auto-height:nth-child(3) > div:nth-child(1) {\n  display: none;\n}\n.MotivodeBaja\n  div.ag-layout-auto-height:nth-child(2)\n  > div:nth-child(1)\n  > div:nth-child(5)\n  > div:nth-child(1) {\n  display: none;\n}\n.MotivodeBaja .estilo-grilla,\n#gridComponent {\n  height: auto !important;\n  margin-bottom: 50px;\n}\n", ""]);

// exports
